import { inject } from '@angular/core';
import { SubscriptionService } from '../../domains/payment/subscription/services/subscription.service';

export const billingResolver = () =>
  inject(SubscriptionService).getBillingInformation();
